<template>
	<div class="c-static-map" v-if="linked">
		<span class="t-visually-hidden">{{description}}</span>
		<img class="c-static-map__image" :src="url" :alt="alt" />
		<div style="margin-left: 5px; margin-right: 5px; z-index: 1; position: absolute; left: 0px; bottom: 0px;">
			<a target="_blank" rel="noopener" :href="mapLink+linkHref" title="Visa på Google Maps" style="position: static; overflow: visible; float: none; display: inline;">
				<div style="width: 66px; height: 26px; cursor: pointer;">
					<img alt="" src="https://maps.gstatic.com/mapfiles/api-3/images/google4_hdpi.png" draggable="false" style="position: absolute; left: 0px; top: 0px; width: 66px; height: 26px; user-select: none; border: 0px; padding: 0px; margin: 0px;">
				</div>
			</a>
		</div>
	</div>
	<div class="c-static-map" v-else>
		<img class="c-static-map__image" :src="url" :alt="alt" />
		<div style="margin-left: 5px; margin-right: 5px; z-index: 1; position: absolute; left: 0px; bottom: 0px;">
			<a target="_blank" rel="noopener" :href="mapLink+linkHref" title="Visa på Google Maps" style="position: static; overflow: visible; float: none; display: inline;">
				<div style="width: 66px; height: 26px; cursor: pointer;">
					<img alt="" src="https://maps.gstatic.com/mapfiles/api-3/images/google4_hdpi.png" draggable="false" style="position: absolute; left: 0px; top: 0px; width: 66px; height: 26px; user-select: none; border: 0px; padding: 0px; margin: 0px;">
				</div>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VStaticMap',
	props: {
		url: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		alt: {
			type: String,
			default: ''
		},
		linked: {
			type: Boolean,
			default: false
		},
		latitude: {
			type: String,
			default: ''
		},
		longitude: {
			type: String,
			default: ''
		},
		api: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			linkHref: "",
			mapLink: "https://www.google.com/maps/place/"
		}
	},
	mounted() {
		if (!this.api) return;
		fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.latitude},${this.longitude}&key=${this.api}`)
			.then(response => response.json())
			.then(data => {
				this.linkHref = data.results[0].formatted_address.split(" ").join("+")
			})
			.catch(e => console.error(e));
	}	
}
</script>